import { kebabCase } from "lodash";
import { computed, makeObservable } from "mobx";
import type { LinkProps } from "next/link";
import type { StoreCreditAccount } from "../StoreCreditAccount";

interface IBudgetItem {
  title: string;
  project: {
    title: string;
    code: string;
  };
}

export class StoreTableDebits {
  storeCreditAccount: StoreCreditAccount;

  constructor(storeCreditAccount: StoreCreditAccount) {
    makeObservable(this);
    this.storeCreditAccount = storeCreditAccount;
  }

  @computed get debits() {
    return this.storeCreditAccount.creditAccount?.debits ?? [];
  }

  @computed get data() {
    return this.debits.map((i) => {
      // @debitStats has always only one of these items:
      // - expenseBudgetItem
      // - ourWorkBudgetItem
      // - brandCreditAccount
      const { expenseBudgetItem, ourWorkBudgetItem, brandCreditAccount } = i;
      const item = { title: "", pathname: "" };

      if (expenseBudgetItem) {
        const projectId = expenseBudgetItem.project.id;
        item.title = StoreTableDebits.composeBudgetItemTitle(expenseBudgetItem);
        item.pathname = `/projects/detail?id=${projectId}#${kebabCase(expenseBudgetItem.title)}`;
      } else if (ourWorkBudgetItem) {
        const projectId = ourWorkBudgetItem.project.id;
        item.title = StoreTableDebits.composeBudgetItemTitle(ourWorkBudgetItem);
        item.pathname = `/projects/detail?id=${projectId}#${kebabCase(ourWorkBudgetItem.title)}`;
      } else if (brandCreditAccount) {
        const creditAccountId = brandCreditAccount.id;
        item.title = brandCreditAccount.title;
        item.pathname = `/credit-accounts/detail?id=${creditAccountId}`;
      }

      return {
        id: i.id,
        amount: i.credit,
        date: i.performed_at,
        usedIn: {
          pathname: item.pathname as LinkProps["href"],
          title: item.title,
        },
      };
    });
  }

  static composeBudgetItemTitle(budgetItem: IBudgetItem): string {
    return `${budgetItem.project.code} ${budgetItem.project.title} – ${budgetItem.title}`;
  }
}
